import {
  queryXcxItemByActId,
  recommend,
  queryCouponList,
  receiveCoupon,
  getPurchaseRecord,
  getSalesInfo,
  getShareURL,
  lottry,
  getActivityInfos,
  batchQueryCanReceiveCouponApi,
  getAppShareURL,
  chainsInfoApi,
  queryXcxNoPubItemByActIdApi,
  getGoodsInfo,
  qryXcxItemPubCatByActIdApi,
  findXcxItemPubByConditionApi,
  viPopFor919Api,
  queryActCodeByUsrRoleAndThemeCodeApi,
  receiveCouponsApi,
  getRecommendInfoByKey,
  isShowPayTips,
  provinceBannerApi,
  getWechatSignatureApi2
} from "@/libs/api.js";
import { getShareInfo } from "@/libs/wxShare.js";
import dragMixins from "@/mixins/dragAble";
import customVideo from "@/components/video.vue";
import couponItem from "@/components/couponItem.vue";
import redPacket from "@/components/redpacket.vue"
import moreSpec from "@/components/moreSpec.vue"
import constants from "vant/lib/sku/constants";
export default {
  name: "chainsDetail",
  components: { customVideo, couponItem,redPacket ,moreSpec},
  mixins: [dragMixins],
  data() {
    return {
      showRed: false,
      bidsArr: [],
      shopNumber: 0,
      isPilot: false,
      uleUrl: "",
      isActive: false,
      chainsDetail: [], // 接龙活动图片与描述
      chainsList: [], // 接龙活动商品
      activityFlag: "", //接龙活动类型  1为套餐活动
      freshActType: "", //是否试点城市  ''  否  1  是
      setMealNum: 1, //套餐数量
      orderList: [], // 购买成功订单列表
      videoUrl: "", // 接龙活动视频地址
      isOver: false, // 接龙活动是否过期
      videoWith: 0, //视频宽度
      videoImg: "", // 视频封面
      transport: "",
      activityId: "",
      cateActivityId: "",
      selfSite: "",
      buttonText: "我要接龙",
      query: {
        activityCode: "",
        pageIndex: 1,
        pageSize: 100,
      },
      shareId: this.getStorage("user", "user.STORE_ID"),
      client_type: "wap_ylxdsq",
      store_id: "",
      subList: [],
      isYlxdsqApp: false,
      shareName: "",
      activityStartTime: "",
      activityEndTime: "",
      lastTime: "",
      isShowItemImg: false,
      currentPopImg: "",
      defaultAvatar: "https://i0.ulecdn.com/i/my/120928/avatar29.png",
      isShowCoupon: false,
      prizeMoney: "", // 优惠券金额
      fullcutAmountLimit: "", // 优惠门槛
      couponList: [],
      totalCount: 0,
      loading: false,
      finished: false,
      finishedText: "",
      isHnApp: false,
      isShowCouponPop: false,
      moreSpecIndex: 0,//多规格商品下标
      moreSpecGoods: null,//多规格商品弹窗数据
      oldCouObj: [],
      couponActivity: "chains_activity_code", //推荐额编码
      tipsQualification: "",
      couponTypes: {
        "1": "店铺券",
        "2": "商品券",
        "3": "运费券",
        "4": "充值券",
        "5": "全场券",
        "6": "品类券",
      },
      couponListData: [],
      nowTime: new Date().getTime(),
      isFixed: true, //按钮是否固定定位
      timeData: "",
      groupNum: "",
      buyerCount: "",
      productNumTotal: "",
      moreText: "点击查看更多商品介绍",
      showMore: false,
      totalNumber: null,
      union_id: "",
      union_ref: "",
      noData: false,
      isBegin: false,
      activitySource: "",
      helpSales: "",
      status: "",
      isShowItemPop: false,
      currentItem: "",
      currentItemIndex: null,
      popIsConfirm: false,
      goodsDesc: "",
      canSmall: false,
      shareSiteId: "",
      groupAmount: "",
      submitPrice: "",
      isShowRightTitle: true, // 右侧二级分类是否显示
      rightNavList: [],
      categoryNavShow: false,
      boxHeight: 0,
      leftNavList: [],
      active: 0,
      isLoad: false,
      cateQuery: {
        activityId: "",
        pageIndex: 1,
        pageSize: 500,
        itemName: "",
        categoryId: "",
      },
      cont: [],
      cateFinished: false,
      cateLoading: false,
      cateFinishedText: "",
      selected: {
        categoryId: "",
        subCateId: "",
      },
      currentNav: "", // 右侧顶部选中
      cateTotalNumber: null,
      cateSelectList: [],
      hd919Data: "", //浮层数据
      showItemType: 0, // 接龙展示形式
      rainImg: "",
      rainUrl: "",
      showCoupon: "",
      bottomTips: "",
      bottomTipsBgImg: "",
      reUrl:'https://fresh-api.'+ this.$uleUrl() +'/order/order/orderConfirm',
      zdAct:['p1381199','p1386440','p1152762','p1152763','p1385398','p1389677', 'p1393146','p1397177','p1401190','p1404216'],
      isShowYS:false,
      mapHref: "https://apis.map.qq.com/tools/locpicker?search=1&type=0&key=OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4&referer=myapp",
      isShowPosPop:false,
      provinceBanner:{},
      wxPath:'',
      envVersion:'',
      isJumpMin:false,
      adid:'',
      showFloatBar:true,//底部浮条状态
      imgList:[],//banner
      groupDisplayType: '', // 1.不显示跟团人记录 2.微信头像+微信昵称 3.仅显示微信头像 4.仅显示微信昵称5.匿名头像+匿名昵称
      selfSiteDisplayPriority1: '',
      selfSiteDisplayPriority2: '',
      allowOtherSelfSiteSelection: '', // 是否允许用户选择自提点
      groupType: '0'
    };
  },
  created() {
    window.addEventListener("resize", this.resizeEvent, true);
    // window.addEventListener("scroll", this.scrollEvent, true);
  },
  mounted() {
    console.log("query11111", this.$route.query);
    this.$cookies.remove('successBack','/', '.'+ this.$uleUrl());
    console.log(this.$cookies.get('ul_adid'),'=====adid====')
    this.adid = this.$cookies.get('ul_adid') || '';
    let locationByCookie = this.$cookies.get('location') || '';
    if(!locationByCookie && !(this.$browser().yzs || this.$browser().ylxdsq || this.$browser().ule || this.$browser().ylxd || this.$browser().ulemax || this.$browser().yzg)){
      this.isShowPosPop = true;
    }else{
      console.log('locationByCookie1111====',locationByCookie)
      if(locationByCookie?.adcode){
        let province = String(locationByCookie.adcode).slice(0, 2) + '0000';
        let adcode='null',areaCode='null',lastStrTwo=locationByCookie.adcode.slice(-2),lastStrFour=locationByCookie.adcode.slice(-4);
        if(lastStrFour!='0000'){
          if(lastStrTwo=='00'){
            //是市级
            adcode=locationByCookie.adcode;
          }else{
            //是区级
            areaCode=locationByCookie.adcode;
            adcode=locationByCookie.adcode.slice(0,-2)+'00';
          }
        }
        provinceBannerApi({adcode:adcode,province:province,areaCode:areaCode}).then(res=>{
          console.log(res)
          if(res.returnCode == '0000' && res.data&&res.data.length > 0){
            // this.provinceBanner.imgUrl = res.data[0].imgUrl || '';
            // if(res.data[0].customAttribute){
            //   this.provinceBanner.link = res.data[0].customAttribute.actUrl || '';
            //   if(res.data[0].customAttribute.appId){
            //     this.isJumpMin = true;
            //   }
            // }
            for(let i=0;i<res.data.length;i++){
              if(res.data[i].customAttribute){
                res.data[i].provinceBannerLink = res.data[i].customAttribute.actUrl || '';
                if(res.data[i].customAttribute.appId){
                  res.data[i].isJumpMin = true;
                }else{
                  res.data[i].isJumpMin = false;
                }
              }
            }
            this.imgList=res.data;
          }
        })
      }
    }
    
    console.log('locationByCookie===',locationByCookie)
    if (this.$browser().ule || this.$browser().ylxd || this.$browser().yzg) {
      window.dsBridge &&
        window.dsBridge.call("setNativeTitle", {
          title: "接龙活动",
        });
    }
    if (this.$browser().ylxdsq) {
      this.callPilotStatus();
    }
    this.isHnApp = navigator.userAgent.indexOf("chinapostHuiNong") > -1 ? true : false;
    this.activityId = this.$route.params.activityId;
    this.cateActivityId = this.activityId.slice(2);
    console.log("cateActivityId==", this.cateActivityId);
    this.freshActType = this.$route.query.freshActType || "";
    console.log("this.$route.query==========", this.$route.query.union_id);
    console.log("this.$route.union_ref==========", this.$route.query.union_ref);
    this.shareSiteId = this.$route.query.siteId || "";
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
    }
    console.log("status====", this.status);
    // 是否不弹优惠券
    if (this.$route.query.showCoupon) {
      this.showCoupon = this.$route.query.showCoupon;
    }
    // 直播间
    if (this.$route.query.union_id) {
      this.union_id = this.$route.query.union_id + ",1016039299";
      // 邮乐app
      if (this.$browser().ule) {
        document.cookie = `ule_srcid=uleApp;domain=.${this.$uleUrl()};path=/;expires=3600`;
      }
      // 小店app
      if (this.$browser().ylxd) {
        document.cookie = `ule_srcid=ylxdApp;domain=.${this.$uleUrl()};path=/;expires=3600`;
      }
    } else {
      this.union_id = "1016039299";
    }
    if (this.$route.query.union_ref) {
      this.union_ref = this.$route.query.union_ref + "," + this.activityId;
    } else {
      this.union_ref = this.activityId;
    }
    if (this.$route.query.buyingGroup && this.$route.query.buyingGroup == "true") {
      this.client_type = "app_huinong";
    } else this.client_type = this.$route.query.ul_sch || this.$route.query.client_type || this.$cookies.get("ul_sch") || this.$cookies.get("client_type");

    if (this.client_type == "app_huinong") {
      document.cookie = `ul_sch=app_huinong;domain=.${this.$uleUrl()};path=/;expires=3600`;
      document.title = "社区团购";
    } else {
      document.title = "邮乐优鲜";
    }
    // 优鲜app
    if (this.$browser().ylxdsq || this.$browser().zyet || (this.isHnApp && !(this.$route.query.buyingGroup && this.$route.query.buyingGroup == "true"))) {
      this.isYlxdsqApp = true;
      this.buttonText = "立即分享";
    }
    this.uleUrl = this.$uleUrl();
    this.store_id = this.$route.query.store_id || this.$route.query.storeid || "";
    this.shareId = this.$route.query.shareId || this.$route.query.share_id || "";
    this.resizeEvent();
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("resize", this.resizeEvent);
    });
    this.$toast.loading({
      duration: 0,
      mask: true,
      message: "加载中...",
    });
    this.getCouponList();
    this.getGoodsDetail(this.$route.params.activityId);
    let params = {
      actCode: this.$route.params.activityId || "",
    };
    this.getNumber(params);
    // this.getOrderList(this.$route.params.activityId);
    this.$nextTick(() => {
      this.scrollview.addEventListener("scroll", this.scrollChange);
    });
    // 红包雨浮标
    if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
      // this.getRainFloat();
    } else {
      this.get919Data(); //获取浮层展示数据
    }
    if (!this.$browser().miniprogram && !this.$browser().ylxdsq) {
      console.log("环境环境");
      // 仅优鲜H5
      this.getBottomTips();
    }
    // if (this.zdAct.includes(this.$route.params.activityId)) {
    //   this.reUrl = 'https://fresh-api.' + this.$uleUrl() +'/order/order/orderConfirm'
    // }
  },
  computed: {
    // 合计
    total() {
      let num = 0;
      this.totalNumber = null;
      this.chainsList.forEach((element) => {
        if (element.items?.length>1) {
          element.items.forEach((good) => {
            if (good.number > 0 && good.storage > 0) {
              num += good.number * good.salPrice;
              if (this.activityFlag == 1) {
                this.totalNumber += Number(good.limitNum);
              } else {
                this.totalNumber += Number(good.number);
              }
            }
          });
        } else {
          if (element.number > 0 && element.storage > 0) {
            num += element.number * element.salPrice;
            if (this.activityFlag == 1) {
              this.totalNumber += Number(element.limitNum);
            } else {
              this.totalNumber += Number(element.number);
            }
          }
        }
      });
      this.submitPrice = num;
      return num;
    },
    cateTotal() {
      let num = 0;
      this.cateTotalNumber = null;
      this.cateSelectList.forEach((element) => {
        if (element.items?.length>1) {
          element.items.forEach((good) => {
            if (good.number > 0 && good.storage > 0) {
              num += good.number * good.salPrice;
              if (this.activityFlag == 1) {
                this.cateTotalNumber += Number(good.limitNum);
              } else {
                this.cateTotalNumber += Number(good.number);
              }
            }
          });
        } else {
          if (element.number > 0 && element.storage > 0) {
            num += element.number * element.salPrice;
            if (this.activityFlag == 1) {
              this.cateTotalNumber += Number(element.limitNum);
            } else {
              this.cateTotalNumber += Number(element.number);
            }
          }
        }
      });
      this.submitPrice = num;
      return num;
    },
    scrollview() {
      return this.$refs.scrollview;
    },
  },
  methods: {
    // 各首banner跳转
    handleProvince(item){
      if(!item.isJumpMin){
        if(item.provinceBannerLink){
          window.location.href = item.provinceBannerLink;
        }
      }
    },
    // 跳转地图
    toSelectAddress() {
      console.log('this.$route=====',this.$route)
      let href = `${location.origin}/yxd/community${this.$route.fullPath}`;
      // let target = this.$route.query.target ? this.$route.query.target : localStorage.getItem("backHref");
      // let href = `${location.origin}/yxd/community${target}`;
      // let urlArr = href.split("?");
      this.mapHref = this.mapHref + `&backurl=${encodeURIComponent(href)}`;
      location.href = this.mapHref;
    },
    closeBottomTips() {
      this.bottomTips = "";
      this.bottomTipsBgImg = "";
    },
    async getBottomTips() {
      const res = await getRecommendInfoByKey({
        key: "pay_success_page_content",
      });
      if (res && res.returnCode == "0000" && res["indexInfo"] && res["indexInfo"].length > 0) {
        if (res["indexInfo"][0].activityCode && res["indexInfo"][0].activityCode != "") {
          if (res["indexInfo"][0].activityCode == this.query.activityCode) {
            if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
              console.log("bdasdf");
              const o = await isShowPayTips();
              if (o && o.code == "0000" && o.data && o.data.isShowPayTips) {
                this.bottomTips = res["indexInfo"][0].bottomTips; // 新
                this.bottomTipsBgImg = res["indexInfo"][0].bottomTipsBgImg; // 新
              } else {
                this.bottomTips = res["indexInfo"][0].oldBottomTips; // 老
                this.bottomTipsBgImg = res["indexInfo"][0].oldBottomTipsBgImg; // 老
              }
            } else {
              this.bottomTips = res["indexInfo"][0].bottomTips; // 新
              this.bottomTipsBgImg = res["indexInfo"][0].bottomTipsBgImg; // 新
            }
          }
        } else {
          if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
            console.log("bdasdf");
            const o = await isShowPayTips();
            if (o && o.code == "0000" && o.data && o.data.isShowPayTips) {
              this.bottomTips = res["indexInfo"][0].bottomTips; // 新
              this.bottomTipsBgImg = res["indexInfo"][0].bottomTipsBgImg; // 新
            } else {
              this.bottomTips = res["indexInfo"][0].oldBottomTips; // 老
              this.bottomTipsBgImg = res["indexInfo"][0].oldBottomTipsBgImg; // 老
            }
          } else {
            this.bottomTips = res["indexInfo"][0].bottomTips; // 新
            this.bottomTipsBgImg = res["indexInfo"][0].bottomTipsBgImg; // 新
          }
        }
      }
    },
    scrollChange() {
      if (this.scrollview.scrollTop > 10) {
        this.canSmall = true;
      } else {
        this.canSmall = false;
      }
    },
    getCouponList() {
      //获取优惠券信息
      recommend({
        sectionKeys: this.couponActivity,
        time: new Date().getTime(),
      }).then((res) => {
        if (res.chains_activity_code) {
          let data = res.chains_activity_code[0].customAttribute;
          this.tipsQualification = data.tipsQualification;
          queryCouponList(data.activityCode).then((res) => {
            if (res.code == "0000") {
              this.couponListData = res.content.prizeCouponDetails;
            }
          });
        }
      });
    },
    getCoupon(coupon) {
      //领取优惠券
      coupon.received = false;
      let channels = {
        wap: "300000", //邮乐wap
        ule: "200000", //邮乐APP
        ulemp: "800001", //邮乐商城微信小程序
        uxd: "600000", //邮乐小店
        usq: "610002", //邮乐优鲜APP
        usqmp: "610001", //邮乐优鲜小程序
        usqh5: "610003", //邮乐优鲜H5
        yzgxd: "400006", //邮小店掌柜版APP
        ysh: "500004", //邮生活
      };
      let data = {
        activityCode: coupon.activityNo,
        couponDetailId: coupon.couponDetailId,
        channel: channels.usqh5,
      };
      if (this.$browser().miniprogram) {
        //小程序
        data.channel = channels.usqmp;
      } else if (this.$browser().ylxdsq) {
        //优鲜APP
        data.channel = channels.usq;
      }
      receiveCoupon(data).then((res) => {
        if (res.code == "0000") {
          //领券成功
          coupon.received = true;
          this.$forceUpdate();
          this.$toast("领取成功");
          //神策埋点
          window.uleStatUtil &&
            window.uleStatUtil.sendSensorTrack("ylyx_CouponsReceive", {
              ylyx_coupon_code: coupon.couponDetailId,
              ylyx_coupon_type: "满减",
              ylyx_coupon_name: coupon.remark || "",
            });
        } else if (res.code == "10000") {
          //未登录/注册
          let currentLink = encodeURIComponent(`https://h5.${process.env.VUE_APP_HOST}/yxd/community${this.$route.fullPath}`); // 当前访问地址
          window.location.href = `https://m.${process.env.VUE_APP_HOST}/muser/user/login?target=${currentLink}`;
        } else if (res.code == "1003") {
          //没资格
          this.$toast(this.tipsQualification);
        } else if (res.code == "3003" || res.code == "3012") {
          //优惠券当日已领完   优惠券当前场已领完
          coupon.dayIsHaveStock = false;
          this.$toast(res.message);
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 获取接龙活动信息
    getGoodsDetail(activityId) {
      // 未发布
      if (this.$route.query.status == 1) {
        queryXcxNoPubItemByActIdApi(activityId)
          .then((res) => {
            if (res) {
              if (res.code === "0000") {
                this.$toast.clear();
                if (res.data) {
                  this.shareName = res.data.activityName;
                  if (res.data.activitySource != 0 && res.data.activitySource != 1) {
                    this.activitySource = "";
                  } else {
                    this.activitySource = res.data.activitySource;
                  }
                  if (res.data.helpSales != 0 && res.data.helpSales != 1) {
                    this.helpSales = "";
                  } else {
                    this.helpSales = res.data.helpSales;
                  }
                  console.log("activitySource", this.activitySource);
                  console.log("helpSales", this.helpSales);
                  this.activityStartTime = this.$moment(res.data.startTime).format("YYYY/MM/DD");
                  this.activityEndTime = this.$moment(res.data.endTime).format("YYYY/MM/DD");
                  this.lastTime = this.$moment(res.data.endTime).diff(this.$moment());
                  console.log("lastTime", this.lastTime);
                  let currentDate = this.$moment(Date.now()).format("YYYYMMDDHHmmss"); // 当前时间
                  let endDate = this.$moment(res.data.endTime).format("YYYYMMDDHHmmss");
                  let startDate = this.$moment(res.data.startTime).format("YYYYMMDDHHmmss");
                  if (currentDate < startDate) {
                    console.log("没有开始");
                    this.isBegin = false;
                  } else {
                    this.isBegin = true;
                  }
                  // 接龙活动状态
                  currentDate > endDate ? (this.isOver = true) : (this.isOver = false);
                  // 接龙活动信息
                  if (res.data.activityDesc) {
                    this.chainsDetail = JSON.parse(res.data.activityDesc) || [];
                    this.chainsDetail.forEach((item) => {
                      if (item.imgUrl) {
                        item.imgUrl = item.imgUrl.replace("http://", "https://");
                      }
                    });
                  }
                  this.transport = res.data.transport;
                  this.activityFlag = res.data.activityFlag;
                  this.selfSite = res.data.selfSite;
                  this.groupNum = res.data.groupNum;
                  this.videoUrl = res.data.videoUrl;
                  this.videoImg = res.data.shareImgUrl.replace("http://", "https://");
                  // 接龙商品列表
                  this.chainsList = res.data.xcxItemVOList;
                  this.shopNumber = this.chainsList.length || 0;
                  console.log("shopNumber", this.shopNumber);
                  if (this.shopNumber > 10) {
                    // 获取分类
                    qryXcxItemPubCatByActIdApi({ activityId: this.cateActivityId }).then((res) => {
                      this.overShow = false;
                      this.cont.push({ goods: [] });
                    });
                    // 获取页面中间高度
                    this.boxHeight = document.documentElement.clientHeight;
                    // this.sidebarWidth = document.querySelector(".van-sidebar").clientWidth + "px";
                    // document.querySelector(".category-nav").style.left = this.sidebarWidth;
                    document.querySelector(".overlay").style.height = document.documentElement.clientHeight;
                    console.log("scrollview===", this.scrollview);
                  }
                  this.chainsList.forEach((item) => {
                    if (item.imgUrl) {
                      item.imgUrl = item.imgUrl.split("|*|")[0];
                      item.imgUrl = item.imgUrl.replace("http://", "https://");
                      item.imgLarge = item.imgUrl;
                      if (!/_l\.jpg/.test(item.imgUrl)) {
                        item.imgUrl = item.imgUrl.replace(".jpg", "_l.jpg");
                      }
                    }
                    if (item.items.length>1) {
                      item.items.forEach((good) => {
                        if (good.imgUrl) {
                          good.imgUrl = good.imgUrl.split("|*|")[0];
                          good.imgUrl = good.imgUrl.replace("http://", "https://");
                          good.imgLarge = good.imgUrl;
                          if (!/_l\.jpg/.test(good.imgUrl)) {
                            good.imgUrl = good.imgUrl.replace(".jpg", "_l.jpg");
                          }
                        }
                        good.number = 0;
                        good.limitNum = good.limitNum ? good.limitNum : 1;
                        good.totalSold = 0;
                      });
                    }
                    item.number = 0;
                    item.limitNum = item.limitNum ? item.limitNum : 1;
                    item.totalSold = 0;
                  });
                  this.chainsList = JSON.parse(JSON.stringify(this.chainsList));
                  getSalesInfo(activityId).then((data) => {
                    if (data.code === "0000") {
                      this.chainsList.forEach((item) => {
                        data.data.forEach((ele, index) => {
                          if (item.listId === ele.listingId) {
                            item.totalSold = data.data[index].totalSold;
                          }
                        });
                        // item.totalSold = data.data[index].totalSold;
                      });
                    }
                  });
                  //微信且不是小程序  初始化微信分享信息
                  if ((this.$browser().wx || this.$browser().wxwork) && !this.$browser().miniprogram) {
                    this.share();
                  }
                  this.$nextTick(() => {
                    // this.scrollEvent()
                  });

                  if (this.$route.query.shareId) {
                    //神策埋点
                    let _this = this;
                    window.uleStatUtil &&
                      window.uleStatUtil.sendSensorTrack("ylxd_ShareClickSuccess", {
                        ylyx_shared_identify_key: "storeid", // 被分享用户  ID-key
                        ylyx_shared_identify_value: _this.$route.query.storeid || _this.$route.query.store_id || "", // 被分享用户 ID-value
                        // exp_id: exp_id,
                        ylyx_share_channel: "微信好友", // 分享渠道
                        ylyx_share_content_type: "接龙", // 分享内容类型
                        ylyx_share_content_name: _this.shareName, // 分享内容名称
                        item_id: activityId, // 物品id
                        ylxd_share_content_id: _this.$route.query.shareId, // 分享内容 ID
                      });
                  }
                } else {
                  this.noData = true;
                }
              } else {
                this.$toast.clear();
                this.noData = true;
              }
            } else {
              this.$toast.clear();
              this.$router.push("/others/pageList");
            }
          })
          .then(() => {
            let isQuery = true; //是否请求查券接口
            if (this.$route.params.activityId == "z178656" || this.$route.params.activityId == "z279452") {
              //z178656 邮政集团乡村振兴团购会（快递）   z279452 邮政集团乡村振兴团购会（自提）
              isQuery = false;
            }
            // 活动未结束-查询优惠券
            if (!this.isOver && isQuery) {
              // 查询优惠券
              let itemIdString = "";
              this.chainsList.forEach((item) => {
                itemIdString += `${item.itemId}:${item.categoryIdPath};`;
              });
              // 去掉最后一个分号
              itemIdString = itemIdString.slice(0, itemIdString.length - 1);
              console.log(itemIdString);
              let query = {
                itemList: itemIdString,
                businessType: "4",
                // userId: this.getStorage("user", "user.STORE_ID") || '',
                pageIndex: 1,
                pageSize: 100,
              };
              if (this.zdAct.includes(this.$route.params.activityId)) {
                console.log('不请求优惠券');
              } else {
                batchQueryCanReceiveCouponApi(query).then((res) => {
                  let data = {};
                  if (res.code == "0000") {
                    data = res.data;
                    if (data.length > 0) {
                      data.map((item) => {
                        let newObj = {
                          available: 1,
                          id: "", //优惠券 id
                          name: "", // 优惠券名称
                          condition: "", // 满减条件
                          description: "",
                          reason: "", // 不可用原因
                          value: null, // 折扣券优惠金额，单位分
                          startAt: null,
                          endAt: null,
                          valueDesc: "", // 折扣券优惠金额文案
                          unitDesc: "元", // 单位文案
                        };
                        switch (item.couponType) {
                          case "1":
                            item.type = "店铺券";
                            break;
                          case "2":
                            item.type = "商品券";
                            break;
                          case "3":
                            item.type = "运费券";
                            break;
                          case "4":
                            item.type = "充值券";
                            break;
                          case "5":
                            item.type = "通用券";
                            break;
                          case "6":
                            item.type = "品类券";
                            break;
                          case "7":
                            item.type = "跨店券";
                            break;
                          default:
                            item.type = "商品券";
                        }
                        if (item.isMultiStore == "true") {
                          item.type = "跨店券";
                        }
                        newObj.id = item.batchId;
                        newObj.name = item.remark || "优惠券名称";
                        newObj.description = item.type;
                        newObj.reason = "";
                        newObj.value = item.amount * 100;
                        newObj.startAt = this.$moment(item.expireBeginDate).format("X");
                        newObj.endAt = this.$moment(item.expireEndDate).format("X");
                        newObj.valueDesc = item.amount;
                        newObj.couponWallFlag = item.couponWallFlag;
                        item.couponName = item.type;
                        if (item.couponType == "7") {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,全站不限金额使用" : "全站满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "全站不限金额使用" : "全站满" + item.fullCutAmount + "减" + item.amount;
                          // newObj.condition = "全站满" + item.fullCutAmount + "减" + item.amount;
                          // item.desc = "全站满" + item.fullCutAmount + "减" + item.amount;
                        } else {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                        }
                        // arr.push(newObj);
                      });
                      this.oldCouObj = data;
                      console.log(data);
                      console.log("showCoupon========", this.showCoupon);
                      if (this.showCoupon == 2) {
                        this.isShowCouponPop = false;
                      } else {
                        this.isShowCouponPop = true;
                      }
                    } else {
                      this.isShowCouponPop = false;
                    }
                  } else {
                    this.isShowCouponPop = false;
                  }
                });
                console.log(query);
                let themeCode = "159523003875223";
                let userOnlyId = this.getStorage("user", "user.STORE_ID");
                let data = {
                  activityCode: "",
                  channel: "610003",
                  fieldId: "",
                  deviceId: "",
                  userOnlyId,
                };
                if (process.env.NODE_ENV === "development") {
                  themeCode = "159471246591743";
                } else if (process.env.NODE_ENV === "testing") {
                  themeCode = "159521105177522";
                } else if (process.env.NODE_ENV === "production") {
                  themeCode = "159523003875223";
                }
                // 是否登录
                if (userOnlyId) {
                  // 是否有场次
                  getActivityInfos(themeCode).then((dt) => {
                    if (dt.code === "0000") {
                      data.activityCode = dt.content[0].activityCode;
                      if (this.client_type === "miniwx_ylxdsq") {
                        data.channel = "610001";
                      }
                      lottry(data).then((rs) => {
                        if (rs.code === "0000") {
                          if (rs.content.prizeInfos.length > 0) {
                            this.isShowCoupon = true;
                            this.couponList = rs.content.prizeInfos;
                          }
                        } else {
                          this.isShowCoupon = false;
                        }
                      });
                    }
                  });
                }

              }
            } else {
              this.isShowCouponPop = false;
            }
          });
      } else {
        queryXcxItemByActId(activityId)
          .then((res) => {
            if (res) {
              if (res.code === "0000") {
                this.$toast.clear();
                if (res.data) {
                  if (res.data.showItemType) {
                    this.showItemType = res.data.showItemType || 0;
                  }
                  console.log('(res.data',res.data)
                  if(res.data.deliverWay == '5'){
                    this.isShowYS = true
                  }
                  // 控制接龙记录配置（接口未下发时默认按 2 处理：头像+昵称，与原空值行为一致）
                  this.groupDisplayType = res.data.groupDisplayType || '2';
                  // 配置到达：非值 1 时解锁列表并触发首次加载（首次自动加载已被拦截）
                  if (this.groupDisplayType != '1') {
                    this.finished = false;
                    this.getOrderList();
                  }
                  // 控制订单确认页默认自提点
                  this.selfSiteDisplayPriority1 = res.data.selfSiteDisplayPriority1;
                  this.selfSiteDisplayPriority2 = res.data.selfSiteDisplayPriority2;
                  this.allowOtherSelfSiteSelection = res.data.allowOtherSelfSiteSelection == 1  ? 1 : ''
                  this.groupType = res.data.groupType
                  this.shareName = res.data.activityName;
                  this.groupAmount = res.data.groupAmount;
                  if (res.data.activitySource != 0 && res.data.activitySource != 1) {
                    this.activitySource = "";
                  } else {
                    this.activitySource = res.data.activitySource;
                  }
                  if (res.data.helpSales != 0 && res.data.helpSales != 1) {
                    this.helpSales = "";
                  } else {
                    this.helpSales = res.data.helpSales;
                  }
                  console.log("activitySource", this.activitySource);
                  console.log("helpSales", this.helpSales);
                  this.activityStartTime = this.$moment(res.data.startTime).format("YYYY/MM/DD");
                  this.activityEndTime = this.$moment(res.data.endTime).format("YYYY/MM/DD");
                  this.lastTime = this.$moment(res.data.endTime).diff(this.$moment());
                  console.log("lastTime", this.lastTime);
                  let currentDate = this.$moment(Date.now()).format("YYYYMMDDHHmmss"); // 当前时间
                  let endDate = this.$moment(res.data.endTime).format("YYYYMMDDHHmmss");
                  let startDate = this.$moment(res.data.startTime).format("YYYYMMDDHHmmss");
                  if (currentDate < startDate) {
                    console.log("没有开始");
                    this.isBegin = false;
                  } else {
                    this.isBegin = true;
                  }
                  // 接龙活动状态
                  currentDate > endDate ? (this.isOver = true) : (this.isOver = false);
                  // 接龙活动信息
                  if (res.data.activityDesc) {
                    this.chainsDetail = JSON.parse(res.data.activityDesc) || [];
                    this.chainsDetail.forEach((item) => {
                      if (item.imgUrl) {
                        item.imgUrl = item.imgUrl.replace("http://", "https://");
                      }
                    });
                  }
                  this.transport = res.data.transport;
                  this.activityFlag = res.data.activityFlag;
                  this.selfSite = res.data.selfSite;
                  this.groupNum = res.data.groupNum;
                  this.videoUrl = res.data.videoUrl;
                  this.videoImg = res.data.shareImgUrl.replace("http://", "https://") || res.data.xcxItemVOList[0].imgUrl.replace("http://", "https://");
                  // 接龙商品列表
                  this.chainsList = res.data.xcxItemVOList;
                  this.chainsList.forEach((item) => {
                    if (item.imgUrl) {
                      item.imgUrl = item.imgUrl.split("|*|")[0];
                      item.imgUrl = item.imgUrl.replace("http://", "https://");
                      item.imgLarge = item.imgUrl;
                      if (!/_l\.jpg/.test(item.imgUrl)) {
                        item.imgUrl = item.imgUrl.replace(".jpg", "_l.jpg");
                      }
                    }
                    if (item.items.length>1) {
                      item.items.forEach((good) => {
                        if (good.imgUrl) {
                          good.imgUrl = good.imgUrl.split("|*|")[0];
                          good.imgUrl = good.imgUrl.replace("http://", "https://");
                          good.imgLarge = good.imgUrl;
                          if (!/_l\.jpg/.test(good.imgUrl)) {
                            good.imgUrl = good.imgUrl.replace(".jpg", "_l.jpg");
                          }
                        }
                        good.number = 0;
                        good.limitNum = good.limitNum ? good.limitNum : 1;
                        good.totalSold = 0;
                      });
                    }
                    item.number = 0;
                    item.limitNum = item.limitNum ? item.limitNum : 1;
                    item.totalSold = 0;
                  });
                  // 如果商品只有一件，商品数量默认为1
                  if (currentDate >= startDate) {
                    if (this.chainsList.length == 1) {
                      if (this.chainsList[0].items?.length>1) {
                        
                      }else
                      this.chainsList[0].number = 1;
                    }
                  }
                  this.chainsList = JSON.parse(JSON.stringify(this.chainsList));
                  this.shopNumber = this.chainsList.length || 0;
                  console.log("shopNumber", this.shopNumber);
                  if ((this.shopNumber > 10 && this.showItemType == 0) || this.showItemType == 2) {
                    // 获取分类
                    qryXcxItemPubCatByActIdApi({ activityId: this.cateActivityId }).then((res) => {
                      this.overShow = false;
                      this.cont.push({ goods: [] });
                      res.data.forEach((item, index) => {
                        // this.leftNavList.push({
                        //   text: item.name,
                        //   id: item.id,
                        //   children: item.children,
                        // });
                        this.leftNavList.push({
                          text: item.name,
                          id: item.id,
                          children: [
                            {
                              id: item.id,
                              name: "全部",
                            },
                          ].concat(item.children),
                        });
                        if (this.selected.categoryId == item.id) {
                          this.active = index;
                        }
                      });
                      this.leftNavList.map((item, index) => {
                        if (item.id == this.$route.query.categoryId) {
                          this.active = index;
                        }
                      });
                      if (this.leftNavList.length > 0) {
                        this.rightNavList = this.leftNavList[this.active].children;
                      }
                      this.isShowRightTitle = true;
                      this.cateQuery.categoryId = this.selected.subCateId || this.leftNavList[this.active]["children"][0].id;
                      this.currentNav = this.selected.subCateId || this.leftNavList[this.active]["children"][0].id;
                      this.fetch();
                    });
                    // 获取页面中间高度
                    this.boxHeight = document.documentElement.clientHeight;
                    // this.sidebarWidth = document.querySelector(".van-sidebar").clientWidth + "px";
                    // document.querySelector(".category-nav").style.left = this.sidebarWidth;
                    // document.querySelector(".overlay").style.height = document.documentElement.clientHeight;
                    console.log("scrollview===", this.scrollview);
                  }
                  getSalesInfo(activityId).then((data) => {
                    if (data.code === "0000") {
                      this.chainsList.forEach((item) => {
                        data.data.forEach((ele, index) => {
                          if (item.listId === ele.listingId) {
                            item.totalSold = data.data[index].totalSold;
                          }
                        });
                        // item.totalSold = data.data[index].totalSold;
                      });
                    }
                  });
                  //微信且不是小程序  初始化微信分享信息
                  if ((this.$browser().wx || this.$browser().wxwork) && !this.$browser().miniprogram) {
                    this.share();
                  }
                  this.$nextTick(() => {
                    this.scrollEvent()
                  });

                  if (this.$route.query.shareId) {
                    //神策埋点
                    let _this = this;
                    window.uleStatUtil &&
                      window.uleStatUtil.sendSensorTrack("ylxd_ShareClickSuccess", {
                        ylyx_shared_identify_key: "storeid", // 被分享用户  ID-key
                        ylyx_shared_identify_value: _this.$route.query.storeid || _this.$route.query.store_id || "", // 被分享用户 ID-value
                        // exp_id: exp_id,
                        ylyx_share_channel: "微信好友", // 分享渠道
                        ylyx_share_content_type: "接龙", // 分享内容类型
                        ylyx_share_content_name: _this.shareName, // 分享内容名称
                        item_id: activityId, // 物品id
                        ylxd_share_content_id: _this.$route.query.shareId, // 分享内容 ID
                      });
                  }
                } else {
                  this.noData = true;
                }
              } else {
                this.$toast.clear();
                this.noData = true;
              }
            } else {
              this.$toast.clear();
              this.$router.push("/others/pageList");
            }
          })
          .then(() => {
            let isQuery = true; //是否请求查券接口
            if (this.$route.params.activityId == "z178656" || this.$route.params.activityId == "z279452") {
              //z178656 邮政集团乡村振兴团购会（快递）   z279452 邮政集团乡村振兴团购会（自提）
              isQuery = false;
            }
            // 活动未结束-查询优惠券
            if (!this.isOver && isQuery) {
              // 查询优惠券
              let itemIdString = "";
              this.chainsList.forEach((item) => {
                itemIdString += `${item.itemId}:${item.categoryIdPath};`;
              });
              // 去掉最后一个分号
              itemIdString = itemIdString.slice(0, itemIdString.length - 1);
              console.log(itemIdString);
              let query = {
                itemList: itemIdString,
                businessType: "4",
                // userId: this.getStorage("user", "user.STORE_ID") || '',
                pageIndex: 1,
                pageSize: 100,
              };
              if (this.zdAct.includes(this.$route.params.activityId)) {
                console.log('不请求优惠券');
              } else {
                batchQueryCanReceiveCouponApi(query).then((res) => {
                  let data = {};
                  if (res.code == "0000") {
                    data = res.data;
                    if (data.length > 0) {
                      data.map((item) => {
                        let newObj = {
                          available: 1,
                          id: "", //优惠券 id
                          name: "", // 优惠券名称
                          condition: "", // 满减条件
                          description: "",
                          reason: "", // 不可用原因
                          value: null, // 折扣券优惠金额，单位分
                          startAt: null,
                          endAt: null,
                          valueDesc: "", // 折扣券优惠金额文案
                          unitDesc: "元", // 单位文案
                        };
                        switch (item.couponType) {
                          case "1":
                            item.type = "店铺券";
                            break;
                          case "2":
                            item.type = "商品券";
                            break;
                          case "3":
                            item.type = "运费券";
                            break;
                          case "4":
                            item.type = "充值券";
                            break;
                          case "5":
                            item.type = "通用券";
                            break;
                          case "6":
                            item.type = "品类券";
                            break;
                          case "7":
                            item.type = "跨店券";
                            break;
                          default:
                            item.type = "商品券";
                        }
                        if (item.isMultiStore == "true") {
                          item.type = "跨店券";
                        }
                        newObj.id = item.batchId;
                        newObj.name = item.remark || "优惠券名称";
                        newObj.description = item.type;
                        newObj.reason = "";
                        newObj.value = item.amount * 100;
                        newObj.startAt = this.$moment(item.expireBeginDate).format("X");
                        newObj.endAt = this.$moment(item.expireEndDate).format("X");
                        newObj.valueDesc = item.amount;
                        newObj.couponWallFlag = item.couponWallFlag;
                        item.couponName = item.type;
                        if (item.couponType == "7") {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,全站不限金额使用" : "全站满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "全站不限金额使用" : "全站满" + item.fullCutAmount + "减" + item.amount;
                          // newObj.condition = "全站满" + item.fullCutAmount + "减" + item.amount;
                          // item.desc = "全站满" + item.fullCutAmount + "减" + item.amount;
                        } else {
                          newObj.condition = item.fullCutAmount == 0 ? item.amount + "元,不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                          item.desc = item.fullCutAmount == 0 ? "不限金额使用" : "满" + item.fullCutAmount + "减" + item.amount;
                        }
                        // arr.push(newObj);
                      });
                      this.oldCouObj = data;
                      console.log(data);
                      console.log("showCoupon========", this.showCoupon);
                      if (this.showCoupon == 2) {
                        this.isShowCouponPop = false;
                      } else {
                        this.isShowCouponPop = true;
                      }
                    } else {
                      this.isShowCouponPop = false;
                    }
                  } else {
                    this.isShowCouponPop = false;
                  }
                });
                console.log(query);
                let themeCode = "159523003875223";
                let userOnlyId = this.getStorage("user", "user.STORE_ID");
                let data = {
                  activityCode: "",
                  channel: "610003",
                  fieldId: "",
                  deviceId: "",
                  userOnlyId,
                };
                if (process.env.NODE_ENV === "development") {
                  themeCode = "159471246591743";
                } else if (process.env.NODE_ENV === "testing") {
                  themeCode = "159521105177522";
                } else if (process.env.NODE_ENV === "production") {
                  themeCode = "159523003875223";
                }
                // 是否登录
                if (userOnlyId) {
                  // 是否有场次
                  getActivityInfos(themeCode).then((dt) => {
                    if (dt.code === "0000") {
                      data.activityCode = dt.content[0].activityCode;
                      if (this.client_type === "miniwx_ylxdsq") {
                        data.channel = "610001";
                      }
                      lottry(data).then((rs) => {
                        if (rs.code === "0000") {
                          if (rs.content.prizeInfos.length > 0) {
                            this.isShowCoupon = true;
                            this.couponList = rs.content.prizeInfos;
                          }
                        } else {
                          this.isShowCoupon = false;
                        }
                      });
                    }
                  });
                }

              }
            } else {
              this.isShowCouponPop = false;
            }
          });
      }
    },
    // 图片点击弹层
    showImgPop(item) {
      this.currentPopImg = item.imgLarge;
      this.isShowItemImg = true;
    },
    // 获取接龙活动订单列表
    getOrderList() {
      // 详情配置未返回：先结束 van-list 的自动加载，不发起请求。
      // 避免值为 1 时记录被提前请求、值为 5 时匿名清洗被绕过导致真实信息泄漏；
      // 配置到达后由详情接口回调手动触发首次加载（参考 community 项目逻辑）
      if (!this.groupDisplayType) {
        this.loading = false;
        this.finished = true;
        return;
      }
      // 值为 1：不显示跟团人记录（同时复位 loading，避免 van-list 卡在加载态）
      if (this.groupDisplayType == '1') {
        this.loading = false;
        this.finished = true;
        return;
      }
      this.query.activityCode = this.$route.params.activityId;
      // if (this.query.activityCode.indexOf("p3") > -1 || this.query.activityCode.indexOf("z3") > -1) {
        this.query.shareUserId = this.$route.query.storeid;
      // }
      getPurchaseRecord(this.query).then((res) => {
        this.loading = false;
        this.finished = false;
        if (res.returnCode === "0000" || res.code == "0000") {
          if (!res.data) {
            this.finished = true;
            this.finishedText = "";
          } else {
            if (this.groupDisplayType == 5) {
              // 展示匿名头像和匿名名称
              res.data.activityPurchaseRecordList.forEach(item => {
                item.wechatIcon = ''
                item.wechatUserName = ''
              })
            }
            this.totalCount = res.data.totalCount;
            this.orderList = res.data.activityPurchaseRecordList;
            if (this.query.pageSize >= res.data.totalCount) {
              this.finished = true;
              this.finishedText = "";
            } else {
              this.query.pageSize += 10;
              this.finished = false;
            }
          }
        } else {
          this.finished = true;
        }
        // this.orderList = res.data.activityPurchaseRecordList;
      });
    },
    // 视频播放
    play() {
      this.$refs.video.playVideo();
    },
    // 获取视频宽度
    resizeEvent() {
      this.videoWith = this.$el.clientWidth;
    },
    // 获取滚动数据
    scrollEvent() {
      try {
        // let ch = document.documentElement.clientHeight;
        // let sclh = document.documentElement.scrollTop;
        // let conH = this.$refs.contentCon.clientHeight;
        // let headH = (this.$refs.head && this.$refs.head.$el.clientHeight) || 0;
        // if (conH + headH - sclh <= ch) {
        //   this.isFixed = false;
        // } else if (ch < conH + headH) {
        //   this.isFixed = true;
        // }
        let listId = this.$route.query.listId 
        if (listId) {
          let chainLOft = this.$refs.chainsList.offsetTop;
          let sss = document.getElementById(`item${listId}`)
          let index = sss.getAttribute('data-index')
          this.handlePopDetail(this.chainsList[index],index)
          window.scrollTo({
            top: chainLOft + sss.offsetTop,
            behavior: "smooth",
          });
        }         
      } catch (error) {}
    },
    // 套餐数量输入过滤
    setMealFormatter() {
      let number = this.setMealNum;
      if (number === "") {
        this.setMealNum = 0;
      } else {
        // 第一位输入0
        if (number.indexOf(0) === 0) {
          console.log("number", number);
          this.setMealNum = number.replace(/0/g, "");
        }
      }
    },
    // 输入过滤
    formatter(index) {
      let number = this.chainsList[index].number;
      // 只有一个商品
      if (this.chainsList.length == 1) {
        if (number === "") {
          this.chainsList[index].number = 1;
        } else {
          // 第一位输入0
          if (number.indexOf(0) === 0) {
            console.log("number", number);
            this.chainsList[index].number = number.replace(/0/g, "");
          }
        }
      } else {
        if (number === "") {
          this.chainsList[index].number = 0;
        } else {
          // 第一位输入0
          if (number.indexOf(0) === 0) {
            console.log("number", number);
            this.chainsList[index].number = number.replace(/0/g, "");
          }
        }
      }
    },
    // 输入过滤
    handleFormatter(index) {
      let number = this.cont[0]["goods"][index].number;
      if (number.indexOf(0) === 0) {
        console.log("number", number);
        this.cont[0]["goods"][index].number = number.replace(/0/g, "");
      }
    },
    // 失去焦点
    goodsNum(item) {
      console.log("item", item);
      if (item.number > 0 && item.number < item.limitNum) {
        item.number = item.limitNum;
      }
    },
    // 加号
    plusClick(index) {
      if (this.chainsList[index].items?.length > 1) {
        this.moreSpecIndex = index;
        this.moreSpecGoods = this.chainsList[index].items;
        return;
      }
      if (this.chainsList[index].number < this.chainsList[index].limitNum) {
        this.chainsList[index].number = this.chainsList[index].limitNum;
      } else this.chainsList[index].number++;
    },
    // 套餐加号
    setMealPlusClick() {
      this.setMealNum++;
    },
    // 减号
    reduceClick(index) {
      if (this.chainsList[index].items?.length > 1) {
        this.moreSpecIndex = index;
        this.moreSpecGoods = this.chainsList[index].items;
        return;
      }
      if (this.chainsList[index].number <= 0) {
        return;
      } else {
        if (this.chainsList[index].number <= this.chainsList[index].limitNum) {
          this.chainsList[index].number = 0;
        } else this.chainsList[index].number--;
      }
    },
    // 套餐减号
    setMealReduceClick() {
      if (this.setMealNum === 0) {
        return;
      } else {
        this.setMealNum--;
      }
    },
    specConfirm(val){
      console.log(val);
      if (val&&val!='null') {
        let total = 0;
        val.forEach((item) => {
          total += Number(item.number);
          if (this.showItemType == 2) {
            let _index = null;
            this.cateSelectList.forEach((good, idx) => {
              if (item.itemId == good.itemId) {
                _index = idx;
              }
            });
            if (_index != null) {
              console.log("_index", _index);
              this.cateSelectList[_index].number = Number(item.number);
            } else {
              this.cateSelectList.push(item);
            }
          }
        });
        if (this.showItemType == 2) {//分类展示模式
          this.cont[0]["goods"][this.moreSpecIndex].items = val;
          this.cont[0]["goods"][this.moreSpecIndex].number = total;
        } else {
          this.chainsList[this.moreSpecIndex].items = val;
          this.chainsList[this.moreSpecIndex].number = total;
        }
      }
      this.moreSpecGoods = null;
    },
    // 提交订单
    async submit() {
      console.log(this.client_type);
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "提交中...",
      });
      this.subList = [];
      this.chainsList.forEach((item) => {
        if (item.number > 0) {
          if (item.items?.length > 1) {
            item.items.forEach((good) => {
              if (good.number > 0) {
                this.subList.push(good.itemId + ":" + good.listId + ":" + good.number + ":" + good.salPrice);
              }
            });
          } else {
            this.subList.push(item.itemId + ":" + item.listId + ":" + item.number + ":" + item.salPrice);
          }
        }
      });
      this.subList = this.subList.toString();
      if (this.$browser().miniprogram) {
        document.cookie = `store_id=${this.store_id};domain=.${this.$uleUrl()};path=/;expires=3600`;
      } else {
        document.cookie = `store_id=${this.store_id};domain=.ule.com;path=/;expires=3600`;
      }
      console.log("groupAmount", this.groupAmount);
      console.log("submitPrice", this.submitPrice);
      // 自动领券
      if (this.oldCouObj && this.oldCouObj.length > 0) {
        this.oldCouObj.forEach((item) => {
          this.bidsArr.push({ batchIdCipher: item.batchId });
        });
        const res = await receiveCouponsApi({
          batchIds: JSON.stringify(this.bidsArr),
          receiveChannelCode: "YLXD_COMMUNITY_VERSION_H5",
        });
        if (res.code == "0000") {
          this.$toast("已帮您自动领取优惠券，下单更省钱");
          await this.sleep(1000);
        }
      }

      if (this.groupAmount) {
        // 提交价格大于起步价
        if (this.groupType != 2) {
          if (this.submitPrice >= this.groupAmount) {
            setTimeout(() => {
              this.$toast.clear();
              console.log('this.$route.fullPath===',this.$route.fullPath)
              let url = this.$route.fullPath;
              let successBack = encodeURIComponent(url);
              this.$cookies.set('successBack', successBack, 14 * 24 * 3600, '/', '.'+ this.$uleUrl());
              this.$refs.orderForm.submit();
              // this.submitDataLink();
            }, 500);
          } else {
            let difference = (Number(this.groupAmount) - Number(this.submitPrice)).toFixed(2);
            this.$toast(`距离起购价还差${difference}元`);
          }
        } else {
          if (this.totalNumber >= this.groupAmount) {
            setTimeout(() => {
              this.$toast.clear();
              console.log('this.$route.fullPath===',this.$route.fullPath)
              let url = this.$route.fullPath;
              let successBack = encodeURIComponent(url);
              this.$cookies.set('successBack', successBack, 14 * 24 * 3600, '/', '.'+ this.$uleUrl());
              this.$refs.orderForm.submit();
              // this.submitDataLink();
            }, 500);
          } else {
            let difference = (Number(this.groupAmount) - Number(this.totalNumber)).toFixed(2);
            this.$toast(`距离起购数量还差${difference}`);
          }
        }
        
      } else {
        setTimeout(() => {
          this.$toast.clear();
          console.log('this.$route.fullPath===',this.$route.fullPath)
          let url = this.$route.fullPath;
          let successBack = encodeURIComponent(url);
          this.$cookies.set('successBack', successBack, 14 * 24 * 3600, '/', '.'+ this.$uleUrl());
          // this.submitDataLink();
          this.$refs.orderForm.submit();
        }, 500);
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    submitDataLink() {
      let url =
        "https://fresh-api." +
        this.$uleUrl() +
        "/order/order/orderConfirm?ul_sch=" +
        this.client_type +
        "&chainActivityFlag=" +
        this.activityFlag +
        "&shareId=" +
        this.shareId +
        "&store_id=" +
        this.store_id +
        "&itemInfo=" +
        this.subList +
        "&transport=" +
        this.transport +
        "&union_id=" +
        this.union_id +
        "&union_ref=" +
        this.union_ref +
        "&selfSite=" +
        this.selfSite +
        "&listingType=104&freshActType=" +
        this.freshActType +
        "&activitySource=" +
        this.activitySource +
        "&helpSales=" +
        this.helpSales +
        "&siteId=" +
        this.shareSiteId +
        "&orderType=1405" + '&adid' + this.adid;
      console.log("提交订单的url=====", url);
      window.location.href = url;
    },
    // 分类提交订单
    async cateSubmit() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "提交中...",
      });
      this.subList = [];
      console.log("cateSelectList", this.cateSelectList);
      this.cateSelectList.forEach((item) => {
        if (item.number > 0) {
          this.subList.push(item.itemId + ":" + item.listId + ":" + item.number + ":" + item.salPrice);
        }
      });
      this.subList = this.subList.toString();
      if (this.$browser().miniprogram) {
        document.cookie = `store_id=${this.store_id};domain=.${this.$uleUrl()};path=/;expires=3600`;
      } else {
        document.cookie = `store_id=${this.store_id};domain=.ule.com;path=/;expires=3600`;
      }
      console.log("groupAmount", this.groupAmount);
      console.log("submitPrice", this.submitPrice);
      console.log("subList", this.subList);
      // 自动领券
      this.oldCouObj &&
        this.oldCouObj.forEach((item) => {
          this.bidsArr.push({ batchIdCipher: item.batchId });
        });
      const res = await receiveCouponsApi({
        batchIds: JSON.stringify(this.bidsArr),
        receiveChannelCode: "YLXD_COMMUNITY_VERSION_H5",
      });
      if (res.code == "0000") {
        this.$toast("已帮您自动领取优惠券，下单更省钱");
        await this.sleep(1000);
      }
      if (this.groupAmount) {
        // 提交价格大于起步价
        if (this.groupType != 2) {
          if (this.submitPrice >= this.groupAmount) {
            setTimeout(() => {
              this.$toast.clear();
              console.log('this.$route.fullPath===',this.$route.fullPath)
              let url = this.$route.fullPath;
              let successBack = encodeURIComponent(url);
              this.$cookies.set('successBack', successBack, 14 * 24 * 3600, '/', '.'+ this.$uleUrl());
              this.$refs.orderForm.submit();
              // this.submitDataLink();
            }, 300);
          } else {
            let difference = (Number(this.groupAmount) - Number(this.submitPrice)).toFixed(2);
            this.$toast(`距离起购价还差${difference}元`);
          }
        } else {
          if (this.cateTotalNumber >= this.groupAmount) {
            setTimeout(() => {
              this.$toast.clear();
              console.log('this.$route.fullPath===',this.$route.fullPath)
              let url = this.$route.fullPath;
              let successBack = encodeURIComponent(url);
              this.$cookies.set('successBack', successBack, 14 * 24 * 3600, '/', '.'+ this.$uleUrl());
              this.$refs.orderForm.submit();
              // this.submitDataLink();
            }, 300);
          } else {
            let difference = (Number(this.groupAmount) - Number(this.cateTotalNumber)).toFixed(2);
            this.$toast(`距离起购数量还差${difference}`);
          }
        }
        
      } else {
        setTimeout(() => {
          this.$toast.clear();
          console.log('this.$route.fullPath===',this.$route.fullPath)
          let url = this.$route.fullPath;
          let successBack = encodeURIComponent(url);
          this.$cookies.set('successBack', successBack, 14 * 24 * 3600, '/', '.'+ this.$uleUrl());
          this.$refs.orderForm.submit();
          // this.submitDataLink();
        }, 300);
      }
    },
    appGetPioltFlag() {
      dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
      dsBridge.register("getPilotStatusResult", (s) => {
        if (typeof s == "string") {
          s = JSON.parse(s);
        }
        if (s) {
          this.freshActType = "1";
          document.cookie = `ispioltCity=1;domain=.${this.$uleUrl()};path=/;expires=3600`;
        }
        this.shareActivity();
      });
    },
    // 分享
    share() {
      // 邮乐生鲜APP
      if (this.$browser().ylxdsq) {
        if (this.$browser().ios && this.$browser().version >= 244) {
          this.appGetPioltFlag();
        } else if (this.$browser().android && this.$browser().version >= 242) {
          this.appGetPioltFlag();
        } else {
          this.shareActivity();
        }
      } else if (this.isHnApp) {
        // console.log(this.chainsDetail);
        this.hnShare();
      } else if (this.$browser().zyet) {
        // 中邮易自提
        this.zyShare();
      }
      // 邮鲜小程序
      else if (this.$browser().miniprogram) {
        this.shareMiniprogram(`您的好友邀请您参与接龙：${this.shareName}`, `您的好友邀请您参与接龙：${this.shareName}`, location.href, this.videoImg, this.$route.params.activityId, 0, 0);
      }
      // 企业微信
      else if (this.$browser().wxwork) {
        // 获取分享id
        let data = {
          shareChannel: "8",
          client_type: "",
          shareName: "邮乐优鲜",
          clientCallType: "H5",
          shareType: "86",
          shareLink: `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`,
          unionRef: this.$route.params.activityId,
        };
        getShareURL(data, "jsoncallback").then((res) => {
          if (res.returnCode === "0000") {
            this.$toast.clear();
            let shareObj = {};
            try {
              shareObj = {
                shareTitle: `您的好友邀请您参与接龙：${this.shareName}`,
                shareContent: `您的好友邀请您参与接龙：${this.shareName}`,
                listImage: this.videoImg || this.chainsList[0].imgUrl,
                url: `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`,
              };
            } catch (e) {}
            let marketerId = (this.$cookies.get("ul_union") || "").split("|")[2];
            let userOnlyId = this.getStorage("user", "user.STORE_ID");
            shareObj.url = `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}?storeid=${userOnlyId}&shareId=${
              res.data.shareId
            }&adid=bsc_qiyewx_fresh_share&ul_union=${this.$cookies.get("ul_union")}`;
            getShareInfo(shareObj, marketerId);
          } else {
            console.log("分享参数查询失败");
          }
        });
        //微信
      } else if (this.$browser().wx) {
        this.shareWx(`您的好友邀请您参与接龙：${this.shareName}`, `您的好友邀请您参与接龙：${this.shareName}`, location.href, this.videoImg || this.chainsList[0].imgUrl);
      } else {
        this.$toast("点击浏览器分享");
      }
    },
    // APP分享
    shareActivity() {
      let data = {
        shareName: this.shareName,
        clientCallType: "H5",
        shareType: 59,
        shareLink: `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`,
        unionRef: this.$route.params.activityId,
      };
      if (this.freshActType) {
        data.shareLink = data.shareLink + "?freshActType=" + this.freshActType;
      }
      getShareURL(data).then((res) => {
        let shareData = res.data;
        let data = {
          listName: this.shareName,
          listImage: [this.videoImg],
          shareCommission: 0,
          shareTitle: `您的好友邀请您参与接龙：${this.shareName}`,
          shareContent: `您的好友邀请您参与接龙：${this.shareName}`,
          WXMiniProgram_Type: 0, // 0正式版，1测试版 2体验版
          WXMiniProgram_DialogName: "微信好友",
          WXMiniProgram_userName: "gh_1e6276474cf7",
          WXMiniProgram_Title: `您的好友邀请您参与接龙：${this.shareName}`,
          WXMiniProgram_pageUrl: shareData.shareUrl3,
          // WXMiniProgram_path: `packageA/solitaire/index?activityCode=${this.$route.params.activityId}`,
          WXMiniProgram_path: "pages/index/index?targetUrl=" + encodeURIComponent(shareData.shareUrl3),
          WXMiniProgram_OriginalId: "gh_1e6276474cf7",
          // WXMiniProgram_path: shareData.miniWxShareInfo && shareData.miniWxShareInfo.path,
          // WXMiniProgram_OriginalId: shareData.miniWxShareInfo && shareData.miniWxShareInfo.originalId,
          WXMiniProgram_image: this.videoImg,

          canShareOkCallBack: true,
          ruleDescription: "",
          imageBanner: this.videoImg,
        };
        let shareObj = this.objectassign({}, data, shareData, {
          listId: this.$route.params.activityId,
          sharePrice: 0,
          marketPrice: 0,
          shareFrom: "0",
        });
        shareObj.shareOptions = "4##1";
        if (this.$browser().ylxdsq) {
          shareObj.shareUrl = shareObj.shareUrl4 || shareObj.shareUrl3;
        }
        console.log("分享内容", shareObj);
        if (window.dsBridge) {
          window.dsBridge.call("generalAction", {
            type: "2",
            ios_action: JSON.stringify(shareObj),
            android_action: JSON.stringify(shareObj),
            maxversion: "999&999",
            needlogin: "false",
          });
        } else {
          window.location.href =
            "uleMobile://uleShare_" + encodeURI(shareObj.shareTitle) + "##" + encodeURI(shareObj.shareContent) + "##" + shareObj.listImage + "##" + shareObj.shareUrl + "##" + shareObj.shareContent;
        }
      });
    },
    // 中邮易自提 暂时没有中邮app内分享
    async zyShare() {
      const shareName = `您的好友邀请您参与接龙~：${this.shareName}`;
      const shareImg = this.videoImg || this.chainsList[0].imgUrl;
      const shareUrl = `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`;
      let data = {
        //中邮接口请求参数
        shareChannel: "9",
        client_type: "app_zyet",
        shareName: "社区团购",
        clientCallType: "H5",
        shareType: "92",
        shareLink: shareUrl,
      };
      const xhr = await this.getShareURL(data);
      if (!xhr) return;
      let zyShare = {
        // 中邮分享参数
        name: shareName,
        picUrl: shareImg,
        qrcode: xhr.shareUrl4,
      };
      console.log(window.myObj, zyShare, "中邮自提");
      if (window.dsBridge && typeof window.dsBridge === "object") {
        console.log("进入分享方法");
        window.dsBridge.call("myObj.ShareUleEvents", JSON.stringify(zyShare));
      }
    },
    // 惠农APP分享
    async hnShare() {
      const shareName = `您的好友邀请您参与接龙~：${this.shareName}`;
      const shareImg = this.videoImg || this.chainsList[0].imgUrl;
      const shareUrl = `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.$route.params.activityId}`;
      let data = {
        // 惠农接口请求参数
        shareChannel: "6",
        client_type: "app_huinong",
        shareName: "社区团购",
        clientCallType: "H5",
        shareType: "59",
        shareLink: shareUrl,
      };
      const xhr = await this.getShareURL(data);
      if (!xhr) return;
      let hnShare = {
        num: 2,
        to: "session",
        title: "社区团购",
        content: shareName,
        image: shareImg,
        url: xhr.url,
      };
      console.log(hnShare, "惠农分享");
      this.$postingApp.shareLink(JSON.stringify(hnShare), (r) => {
        console.log("这里是分享回调方法", r);
        callback(r);
      });
    },
    // 分享获取参数
    async getShareURL(data) {
      const xhr = await getShareURL(data, "jsoncallback");
      if (xhr.returnCode === "0000") {
        this.$toast.clear();
        return xhr.data;
      } else {
        console.log("分享参数查询失败");
      }
    },
    handleClosePop() {
      console.log(123);
    },
    downChange(e) {
      if (e.hours < 10) {
        e.hours = `0${e.hours}`;
      }
      if (e.minutes < 10) {
        e.minutes = `0${e.minutes}`;
      }
      if (e.seconds < 10) {
        e.seconds = `0${e.seconds}`;
      }
    },
    // 接龙结束
    activelFinish() {
      this.isOver = true;
    },
    // 锚点跳转
    goAnchor(id) {
      var anchor = `.${id}`;
      document.querySelector(anchor).scrollIntoView({
        behavior: "smooth",
      });
    },
    goSearchPos() {
      document.querySelector(".search").scrollIntoView({
        behavior: "smooth",
      });
    },
    // 查询人数和成单
    getNumber(params) {
      chainsInfoApi(params).then((res) => {
        console.log(res);
        if (res.code == "0000") {
          let { buyerCount, productNumTotal } = res.data;
          this.buyerCount = buyerCount;
          this.productNumTotal = productNumTotal;
        }
      });
    },
    // 更多点击
    changeMore() {
      this.showMore = !this.showMore;
      if (this.showMore) {
        this.moreText = "点击隐藏更多商品介绍";
      } else {
        this.moreText = "点击查看更多商品介绍";
      }
    },
    // 优鲜APP中获取是否试点
    callPilotStatus: function() {
      var that = this;
      window.dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
      window.dsBridge.register("getPilotStatusResult", function(s) {
        that.isPilot = s;
      });
    },
    noBegin() {
      this.$toast("活动尚未开始");
    },
    // 商品点击弹层
    handlePopDetail(item, index) {
      console.log(item);
      if (item.items?.length > 1) {
        this.moreSpecIndex = index;
        this.moreSpecGoods = item.items;
        return;
      }
      this.currentItem = "";
      this.goodsDesc = "";
      this.currentItem = { ...this.currentItem, ...item };
      this.currentItemIndex = index;
      getGoodsInfo(item.listId).then((res) => {
        if ((res.returnCode === "0000" || res.code === "0000") && res.data) {
          this.goodsDesc = res.data.replace(/src/g, "load-src").replace(/data-original/g, "src");
        }
      });
      // console.log("item", item);
      if (this.currentItem.number == 0) {
        this.currentItem.number = 1;
      }
      this.isShowItemPop = true;
      const scrollview = this.scrollview;
      // scrollview.addEventListener("scroll", this.scrollChange, true);
    },
    // 搜索商品点击弹层
    handlePopCateDetail(item, index) {
      console.log("cate-item", item);
      this.currentItem = "";
      this.goodsDesc = "";
      this.currentItem = { ...this.currentItem, ...item };
      this.currentItemIndex = index;
      console.log("currentItem", this.currentItem);
      getGoodsInfo(item.listId).then((res) => {
        if ((res.returnCode === "0000" || res.code === "0000") && res.data) {
          this.goodsDesc = res.data.replace(/src/g, "load-src").replace(/data-original/g, "src");
        }
      });
      if (this.currentItem.number == 0) {
        this.currentItem.number = 1;
      }
      this.isShowItemPop = true;
      const scrollview = this.scrollview;
    },
    // closeItemPop() {
    // console.log("走了关闭", this.popIsConfirm);
    // if (this.currentItem.number == 1 && !this.popIsConfirm) {
    //   console.log('走了这里',this.popIsConfirm)
    //   this.chainsList[this.currentItemIndex].number = 0;
    // }
    // },
    handlePopConfirm() {
      this.chainsList[this.currentItemIndex].number = this.currentItem.number;
      this.isShowItemPop = false;
    },
    handlePopCateConfirm() {
      let _index = null;
      this.cateSelectList.forEach((item, idx) => {
        if (this.cont[0]["goods"][this.currentItemIndex].itemId == item.itemId) {
          _index = idx;
        }
      });
      if (_index != null) {
        console.log("_index", _index);
        this.cateSelectList[_index].number = this.currentItem.number;
        this.cont[0]["goods"][this.currentItemIndex].number = this.currentItem.number;
      } else {
        this.cateSelectList.push(this.cont[0]["goods"][this.currentItemIndex]);
        this.cont[0]["goods"][this.currentItemIndex].number = this.currentItem.number;
      }
      console.log("cateSelectList", this.cateSelectList);
      this.isShowItemPop = false;
    },
    //获取浮层展示数据
    get919Data() {
      viPopFor919Api({ visualChannel: "wap_ylxdsq_jl" }).then((res) => {
        console.log("===res", res);
        if (res.code == "0000") {
          if (res.content) {
            this.hd919Data = res.content[0];
            this.sendTrack('resourceExposure',res.content[0])
          } else {
            this.hd919Data = "";
          }
        } else {
          this.hd919Data = "";
        }
      });
    },
    // 浮层点击
    handleTo919Link() {
      if (this.hd919Data.act_type == "20") {
        // 红包抽奖 非试点
        this.showRed = true
        this.sendTrack('resourceClick',this.hd919Data)
        console.log('抽奖', this.showRed)
      } else if (this.hd919Data.h5_url) {
        let storeid = this.$route.query.storeid || this.$route.query.store_id;
        if (storeid) {
          if (this.hd919Data.h5_url.indexOf("?") > -1) {
            this.hd919Data.h5_url = `${this.hd919Data.h5_url}&storeid=${storeid}&shareId=${this.$route.query.shareId}`;
          } else {
            this.hd919Data.h5_url = `${this.hd919Data.h5_url}?storeid=${storeid}&shareId=${this.$route.query.shareId}`;
          }
        }
        console.log("跳转链接=====", this.hd919Data.h5_url);
        location.href = this.hd919Data.h5_url;
      }
    },
    sendTrack(event,item) {
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack(event, {
        ule_title: '接龙详情页面',
        resource_type: '浮标',
        resource_name: '接龙页-浮标',
        resource_content: 0,
        resource_item_type: '活动',
        resource_item_id: '',
        resource_forward_url: '',
        // ul_aid: 'uxcommunity_float',
        ul_aid:`uxcommunity_float_${item && item.title || ''}`
      });
    },
    // 红包雨弹层
    getRainFloat() {
      queryActCodeByUsrRoleAndThemeCodeApi({ channel: "wap_ylxdsq" }).then((res) => {
        console.log("res=======", res);
        if (res.code == "0000") {
          if (res.data) {
            let userRole = res.data[0].userRole;
            let conformImg = "",
              conformUrl = "",
              nullImg = "",
              nullUrl = "";
            res.data.forEach((item) => {
              // vip会员
              if (item.userLimit == "103" && (userRole == "1" || userRole == "2")) {
                if (item.fieldInfos.length > 0) {
                  conformImg = item.float_pic;
                  conformUrl = item.activityUrl;
                }
              }
              // 普通会员
              else if (item.userLimit == "0" && (userRole == "0" || userRole == "3")) {
                if (item.fieldInfos.length > 0) {
                  conformImg = item.float_pic;
                  conformUrl = item.activityUrl;
                }
              }
              // 全部默认
              if (item.userLimit == null || item.userLimit == "") {
                if (item.fieldInfos.length > 0) {
                  if (userRole == "1" || userRole == "2") {
                    nullImg = item.float_pic;
                  } else {
                    nullImg = item.float_pic;
                  }
                  nullUrl = item.activityUrl;
                }
              }
            });
            this.rainImg = conformImg || nullImg || "";
            this.rainUrl = conformUrl || nullUrl || "";

            if (this.rainUrl) {
              if (this.rainUrl.indexOf("?") > -1) {
                this.rainUrl = `${this.rainUrl}&storeid=${this.store_id}&shareId=${this.$route.query.shareId}`;
              } else {
                this.rainUrl = `${this.rainUrl}?storeid=${this.store_id}&shareId=${this.$route.query.shareId}`;
              }
            }
          }
        }
        if (this.rainImg == "") {
          this.get919Data(); //获取浮层展示数据
        }
      });
    },
    // 红包雨点击
    handleTobuoy() {
      console.log("process.env.NODE_ENV", process.env.NODE_ENV);
      let envVersion = {
        development: "trial",
        testing: "trial",
        production: "release",
      }[process.env.NODE_ENV];
      console.log("env===", envVersion);
      if (this.rainUrl) {
        console.log("跳转链接=====", this.rainUrl);
        app.toH5Page(encodeURIComponent(this.rainUrl), true);
      }
    },
    stepChangeDebounceRight: _.debounce(function(e) {
      let _this = this;
      console.log(e);
      _this.rightNavChange(e);
    }, 500),
    navChangeDebounceLeft: _.debounce(function(e) {
      let _this = this;
      console.log(e);
      _this.changeTab(e);
    }, 500),
    // 右侧箭头切换
    showMoreCategory() {
      this.categoryNavShow = !this.categoryNavShow;
    },
    // 获取商品列表
    fetch() {
      this.cateQuery.activityId = this.cateActivityId;
      findXcxItemPubByConditionApi(this.cateQuery).then((res) => {
        this.cateLoading = false;
        if (res.returnCode === "0000" && res.data) {
          // 无数据
          if (res.data.result.length === 0) {
            this.cateFinished = true;
          } else {
            // 活动列表下拉load事件
            if (document.querySelector(".van-tree-select__content").scrollTop === 0) {
              setTimeout(() => {
                document.querySelector(".van-tree-select__content").scrollTo(0, 1);
              }, 10);
            }
            res.data.result.forEach((item) => {
              if (~item.imgUrl.indexOf("http://")) {
                item.imgUrl = item.imgUrl.replace("http://", "https://");
              }
            });
            this.cateQuery.pageIndex++;
            let totalPage = Math.floor(this.pageCount(res.data.totalRecords));
            this.cont[0]["goods"] = this.cont[0]["goods"].concat(res.data.result);
            this.cont[0]["goods"].forEach((item) => {
              this.$set(item, "number", 0);
              if (item.imgUrl) {
                item.imgUrl = item.imgUrl.split("|*|")[0];
                item.imgUrl = item.imgUrl.replace("http://", "https://");
                item.imgLarge = item.imgUrl;
                if (!/_l\.jpg/.test(item.imgUrl)) {
                  item.imgUrl = item.imgUrl.replace(".jpg", "_l.jpg");
                }
              }
              if (item.items?.length>1) {
                item.items.forEach((good) => {
                  if (good.imgUrl) {
                    good.imgUrl = good.imgUrl.split("|*|")[0];
                    good.imgUrl = good.imgUrl.replace("http://", "https://");
                    good.imgLarge = good.imgUrl;
                    if (!/_l\.jpg/.test(good.imgUrl)) {
                      good.imgUrl = good.imgUrl.replace(".jpg", "_l.jpg");
                    }
                  }
                  good.number = 0;
                  good.limitNum = good.limitNum ? good.limitNum : 1;
                });
              }
            });
            this.cont[0]["goods"].filter((v) => {
              this.cateSelectList.some((val) => {
                if (val.listId == v.listId) {
                  v.number = val.number;
                }
              });
            });
            console.log("goods", this.cont[0]["goods"]);
            if (this.cateQuery.pageIndex > totalPage) {
              this.cateFinished = true;
              this.cateFinishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.cateFinished = false;
            }
          }
          let first = "",
            second = "";
          console.log("categoryIds", res.data.result[0].categoryIds);
          console.log("this.cateQuery.categoryId", this.cateQuery.categoryId);
          // first = res.data.result[0].categoryIds[0];
          // second = res.data.result[0].categoryIds[1];
          // this.cateQuery.categoryId = second;
          // console.log("active", this.active);
          // this.leftNavList.forEach((item, index) => {
          //   if (item.id == first) {
          //     this.active = index;
          //   }
          // });
        } else {
          this.cateFinished = true;
          this.cateFinishedText = "我已到达底部, 暂无其他数据啦~~";
        }
      });
    },
    // 计算总页数
    pageCount(totalCount) {
      return (totalCount + this.cateQuery.pageSize - 1) / this.cateQuery.pageSize;
    },
    // 左侧切换
    changeTab(index) {
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      this.cont[0]["goods"] = [];
      this.rightNavList = this.leftNavList[index].children;
      this.currentNav = this.rightNavList[0].id;
      this.cateQuery.pageIndex = 1;
      this.cateQuery.categoryId = this.currentNav;
      this.cateLoading = false;
      this.cateFinished = false;
      this.isLoad = true;
      this.setSelectedCate("categoryId", this.leftNavList[index].id);
      this.setSelectedCate("subCateId", this.currentNav);
      if (index !== 0) {
        document.querySelector(".van-tree-select__content").classList.add("left-top-radius");
        document.querySelector(".category-nav").classList.add("left-top-radius");
      } else {
        document.querySelector(".van-tree-select__content").classList.remove("left-top-radius");
        document.querySelector(".category-nav").classList.remove("left-top-radius");
      }
      window.uleStatUtil &&
        window.uleStatUtil.sendSensorTrack("navigationBarClick", {
          navigation_bar_type: "左侧",
          navigation_bar_name: this.leftNavList[index].text,
        });
      // this.fetch();
    },
    handleToserch() {
      if (this.cateQuery.itemName) {
        this.$toast.loading({
          duration: 500,
          mask: true,
          message: "加载中...",
        });
        this.cateQuery.pageIndex = 1;
        // this.cateQuery.categoryId = '';
        this.cateLoading = false;
        this.cateFinished = false;
        this.isLoad = true;
        this.cont[0]["goods"] = [];
      }
      window.uleStatUtil &&
        window.uleStatUtil.sendSensorTrack("searchButtonClick", {
          ule_title: "接龙页",
          search_type: "通用商品搜索",
          search_keyword: this.cateQuery.itemName,
          search_keyword_type: "",
        });
    },
    handleResetCate() {
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      this.cateQuery.itemName = "";
      this.cateQuery.pageIndex = 1;
      this.cateLoading = false;
      this.cateFinished = false;
      this.isLoad = true;
      this.cont[0]["goods"] = [];
    },
    // 右侧点击
    rightNavChange(item) {
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      this.cont[0]["goods"] = [];
      this.cateQuery.categoryId = item.id;
      this.currentNav = item.id;
      this.cateQuery.pageIndex = 1;
      this.cateLoading = false;
      this.cateFinished = false;
      this.isLoad = true;
      this.setSelectedCate("subCateId", this.currentNav);
      // this.fetch();
    },
    setSelectedCate(type, value) {
      this.selected[type] = value;
      // localStorage.setItem("ylxdsq.category", JSON.stringify(this.selected));
    },
    // 分类加
    handlePlusClick(index) {
      // console.log("index", index);
      if (this.cont[0]["goods"][index].items?.length > 1) {
        this.moreSpecIndex = index;
        this.moreSpecGoods = this.cont[0]["goods"][index].items;
        return;
      }
      let _index = null;
      // item.number = 1;
      this.cont[0]["goods"][index].number++;
      // console.log('this.cont[0]["goods"][index]', this.cont[0]["goods"][index]);
      this.cateSelectList.forEach((item, idx) => {
        if (this.cont[0]["goods"][index].itemId == item.itemId) {
          _index = idx;
        }
      });
      if (_index != null) {
        console.log("_index", _index);
        this.cateSelectList[_index].number = this.cont[0]["goods"][index].number;
      } else {
        this.cateSelectList.push(this.cont[0]["goods"][index]);
      }
      console.log("cateSelectList", this.cateSelectList);
    },
    // 减号
    handleReduceClick(index) {
      if (this.cont[0]["goods"][index].number <= 0) {
        return;
      } else {
        if (this.cont[0]["goods"][index].items?.length > 1) {
          this.moreSpecIndex = index;
          this.moreSpecGoods = this.cont[0]["goods"][index].items;
          return;
        }
        if (this.cont[0]["goods"][index].number <= this.cont[0]["goods"][index].limitNum) {
          this.cont[0]["goods"][index].number = 0;
        } else this.cont[0]["goods"][index].number--;
        console.log(this.cont[0]["goods"][index].number);
        if (this.cont[0]["goods"][index].number == 0) {
          let _index = null;
          console.log("到0判断");
          this.cateSelectList.forEach((item, idx) => {
            if (this.cont[0]["goods"][index].itemId == item.itemId) {
              console.log(`删除第${idx}个`);
              _index = idx;
            }
          });
          this.cateSelectList.splice(_index, 1);
        }
      }
    },
    //隐藏浮条
    removeFloatBar() {
      this.showFloatBar = false;
    },
    toFloatUrl(){
      this.handleTo919Link();
    }
  },
  filters: {
    useConditions(val) {
      return val && val.replace(/\.(0|00)元/, "元");
    },
  },
};
